export default __webpack_public_path__ + "static/media/9.33fa9b7f.png";